// extracted by mini-css-extract-plugin
module.exports = {"previewNotice":"PreviewNotice_previewNotice__bw4qw"};